<div class="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-teal-50 flex items-center justify-center p-4 font">
  <div class="max-w-2xl w-full bg-white rounded-3xl shadow-2xl overflow-hidden">
    <div class="bg-gradient-to-r from-emerald-500 to-teal-500 h-2"></div>
    <div class="p-8 md:p-12 text-center">
      <div class="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-emerald-100 to-teal-100 rounded-full mb-6 animate-pulse">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
          class="lucide lucide-check-circle2 w-12 h-12 text-emerald-600">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="m9 12 2 2 4-4"></path>
        </svg>
      </div>
      <div class="flex items-center justify-center gap-2 mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" width="24"
          height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" class="lucide lucide-sparkles w-6 h-6 text-amber-500">
          <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z">
          </path>
          <path d="M5 3v4"></path>
          <path d="M19 17v4"></path>
          <path d="M3 5h4"></path>
          <path d="M17 19h4"></path>
        </svg>
        <h1 class="text-4xl md:text-5xl font-bold text-gray-900">{{'VALUES.CONGRATULATIONS' | translate}}</h1>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="lucide lucide-sparkles w-6 h-6 text-amber-500">
          <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z">
          </path>
          <path d="M5 3v4"></path>
          <path d="M19 17v4"></path>
          <path d="M3 5h4"></path>
          <path d="M17 19h4"></path>
        </svg>
      </div>
      <p class="text-xl md:text-2xl text-gray-700 font-medium mb-3">{{'VALUES.PROFILE_MATCH' | translate}}</p>
      <p class="text-lg text-gray-600 mb-8">{{'VALUES.IMPRESSED_APPLICATION' | translate}}</p>
      <div class="h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent mb-8"></div>
      <button *ngIf="calendlyProfileUrl || externalCalendarUrl"
        (click)="handleCalendarClick()"
        class="group relative w-full md:w-auto inline-flex items-center justify-center gap-3 px-12 py-5 bg-gradient-to-r from-emerald-600 to-teal-600 text-white text-xl font-semibold rounded-2xl shadow-lg hover:shadow-2xl transform hover:scale-105 transition-all duration-300 mb-8">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"  stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-calendar w-6 h-6">
          <path d="M8 2v4"></path>
          <path d="M16 2v4"></path>
          <rect width="18" height="18" x="3" y="4" rx="2"></rect>
          <path d="M3 10h18"></path>
        </svg>
        <span>{{'VALUES.SCHEDULE_INTERVIEW' | translate}}</span>
        <div class="absolute inset-0 rounded-2xl bg-white opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
      </button>
      <div class="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl p-6 mb-6">
        <p class="text-gray-700 leading-relaxed">{{'VALUES.HIRING_TEAM_EXCITED' | translate}}</p>
      </div>
      <div class="space-y-3 text-left max-w-md mx-auto">
        <div class="flex items-start gap-3 text-gray-600">
          <div class="w-2 h-2 bg-emerald-500 rounded-full mt-2 flex-shrink-0"></div>
          <p>{{'VALUES.APPLICATION_SUBMITTED_SUCCESSFULLY' | translate}}</p>
        </div>
        <div class="flex items-start gap-3 text-gray-600">
          <div class="w-2 h-2 bg-emerald-500 rounded-full mt-2 flex-shrink-0"></div>
          <p>{{'VALUES.NEXT_STEP' | translate}}</p>
        </div>
        <div class="flex items-start gap-3 text-gray-600">
          <div class="w-2 h-2 bg-emerald-500 rounded-full mt-2 flex-shrink-0"></div>
          <p>{{'VALUES.CONFIRMATION_EMAIL' | translate}}</p>
        </div>
      </div>
      <p class="text-gray-500 text-sm mt-8 pt-6 border-t border-gray-200">{{'VALUES.THANK_YOU_FOR' | translate}}</p>
    </div>
  </div>
   <!-- Animated background circles -->
   <div class="fixed inset-0 -z-10 overflow-hidden">
    <div class="absolute top-1/4 left-1/4 w-32 h-32 bg-green-200 rounded-full opacity-20 animate-pulse"></div>
    <div class="absolute bottom-1/4 right-1/4 w-24 h-24 bg-green-300 rounded-full opacity-15 animate-pulse delay-1000"></div>
    <div class="absolute top-3/4 left-1/3 w-16 h-16 bg-green-400 rounded-full opacity-10 animate-pulse delay-2000"></div>
  </div>

  <!-- Calendly Popup Modal -->
  <div
    *ngIf="showCalendlyPopup"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-xl shadow-lg w-full max-w-3xl relative">
      <button
        (click)="closeCalendlyPopup()"
        class="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-xl font-bold">
        ×
      </button>
      <div id="calendly-embed" style="min-width:320px; height:700px;"></div>
    </div>
  </div>
</div>